/* Daza Organic · «Lo que dejamos fuera».
   1) Los sellos entran con un fundido + ascenso leve, uno detrás de otro
      (ver el escalonado por nth-child en daza-conscious-beauty.css), la
      primera vez que la banda entra en pantalla. Mismo mecanismo que
      daza-relato-cita.js: una clase que el CSS ya sabe animar, disparada
      una sola vez por IntersectionObserver.
   2) La marquesina de móvil se desplaza sola, pero es un <div> con scroll
      nativo de verdad (overflow-x, ver CSS): el usuario puede arrastrarla
      con el dedo en cualquier momento. El auto-avance mueve scrollLeft a
      mano en vez de animar un transform, para que ambos mecanismos —el
      automático y el del usuario— usen la MISMA propiedad y no se peleen.
      El contenido está duplicado ×2 en el Liquid; cuando el scroll pasa de
      la mitad (el ancho de una copia), se resta esa mitad sin transición,
      así que el bucle no tiene ni principio ni fin visibles. */
(function () {
  'use strict';

  function iniciarReveal() {
    var bandas = document.querySelectorAll('.s-conscious__sellos:not([data-listo])');
    if (!bandas.length) return;

    var soportado = 'IntersectionObserver' in window;

    bandas.forEach(function (banda) {
      banda.dataset.listo = '1';

      if (!soportado) {
        banda.classList.add('es-visible');
        return;
      }

      var observer = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          observer.disconnect();
          banda.classList.add('es-visible');
        });
      }, { threshold: 0.3 });
      observer.observe(banda);
    });
  }

  function iniciarMarquesina() {
    var pistas = document.querySelectorAll('.s-conscious__marquesina:not([data-listo])');
    if (!pistas.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion:reduce)');
    var VELOCIDAD = 28; // px/s

    pistas.forEach(function (pista) {
      pista.dataset.listo = '1';

      var track = pista.querySelector('.s-conscious__marquesina-track');
      if (!track) return;

      var pausado = false;
      var reanudarTimer = null;
      var anterior = null;
      // scrollLeft es un entero: sumarle un incremento menor a 0,5px cada
      // frame (28px/s a 60fps ≈ 0,47px) se quedaba en el mismo entero al
      // redondear y el auto-avance no se movía nunca. Se acumula aparte, en
      // coma flotante, y solo AL FINAL se vuelca al scrollLeft real.
      var posicion = 1;

      function mitad() {
        return track.scrollWidth / 2;
      }

      function envolver(valor) {
        var m = mitad();
        if (valor >= m) return valor - m;
        if (valor < 0) return valor + m;
        return valor;
      }

      function paso(ahora) {
        if (anterior === null) anterior = ahora;
        var dt = (ahora - anterior) / 1000;
        anterior = ahora;
        if (!pausado) {
          posicion = envolver(posicion + VELOCIDAD * dt);
          pista.scrollLeft = posicion;
        }
        requestAnimationFrame(paso);
      }

      function pausar() {
        pausado = true;
        clearTimeout(reanudarTimer);
      }
      function reanudarPronto() {
        clearTimeout(reanudarTimer);
        reanudarTimer = setTimeout(function () {
          pausado = false;
          anterior = null;
        }, 2200);
      }

      // Punto de partida: a la mitad de la primera copia, así el usuario
      // puede arrastrar hacia cualquier lado desde el primer instante sin
      // toparse con el borde 0 del contenido duplicado.
      pista.scrollLeft = posicion;

      /* El arrastre NO se deja en manos del scroll nativo del navegador:
         un click-and-drag con MOUSE no hace scroll en un div normal —solo
         el touch real lo hace—, así que en escritorio (y en cualquier
         emulación sin gesto táctil genuino) el intento de arrastrar no
         movía nada. Pointer Events cubre mouse, touch y lápiz con el MISMO
         código: se mueve scrollLeft a mano siguiendo al puntero, como un
         "grab & drag" de verdad. */
      var arrastrando = false;
      var moviendoseHorizontal = false;
      var pointerId = null;
      var inicioX = 0;
      var inicioScroll = 0;
      var UMBRAL = 6; // px antes de decidir que el gesto es horizontal

      function onPointerDown(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        arrastrando = true;
        moviendoseHorizontal = false;
        pointerId = e.pointerId;
        inicioX = e.clientX;
        inicioScroll = pista.scrollLeft;
      }

      function onPointerMove(e) {
        if (!arrastrando || e.pointerId !== pointerId) return;
        var dx = e.clientX - inicioX;
        if (!moviendoseHorizontal) {
          if (Math.abs(dx) < UMBRAL) return;
          moviendoseHorizontal = true;
          pausar();
          if (pista.setPointerCapture) {
            try { pista.setPointerCapture(pointerId); } catch (err) { /* noop */ }
          }
        }
        e.preventDefault();
        posicion = envolver(inicioScroll - dx);
        pista.scrollLeft = posicion;
      }

      function onPointerUp(e) {
        if (!arrastrando || e.pointerId !== pointerId) return;
        arrastrando = false;
        if (pista.releasePointerCapture) {
          try { pista.releasePointerCapture(pointerId); } catch (err) { /* noop */ }
        }
        if (moviendoseHorizontal) reanudarPronto();
      }

      pista.addEventListener('pointerdown', onPointerDown);
      pista.addEventListener('pointermove', onPointerMove);
      pista.addEventListener('pointerup', onPointerUp);
      pista.addEventListener('pointercancel', onPointerUp);

      /* Con «reducir movimiento» solo se apaga el auto-avance; el arrastre
         se queda. Antes se salía de toda la función: sin JS de arrastre y con
         touch-action:pan-y en el CSS (que bloquea el scroll horizontal
         nativo), la banda quedaba inmóvil e imposible de mover. */
      if (!reduce.matches) requestAnimationFrame(paso);
    });
  }

  function iniciar() {
    iniciarReveal();
    iniciarMarquesina();
  }

  iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
